import React from 'react';
import { Checkbox, FormControl } from 'rsuite';
import { useLocation } from '../hooks/useLocation';

export const FilterCheckbox = ({ name, text }) => {
  const { params, go } = useLocation();
  const value = params[name] || '';

  return (
    <>
      <FormControl
        className="filter"
        accepter={Checkbox}
        value={'1'}
        checked={value === '1'}
        onChange={(v, checked) => {
          const vals = { [name]: checked ? v : null };
          go({ ...params, ...vals });
        }}
      >
        {text}
      </FormControl>
    </>
  );
};
